import { useBaseComponent } from 'basics/component/base-component';
import { FileViewer } from 'components/FileViewer/FileViewer';
import Modal from 'components/Modal';
import moment from 'moment-jalaali';
import { ReactElement } from 'react';
import { convertDigitToProperFormat } from 'utils/number';
import messages from './TaskAttachmentsModal-messages';
import {
  AttachmentFileHolder,
  AttachmentModalDownloadLink,
  AttachmentModalImageHolder,
  AttachmentModalInfo,
  PrevNextButton,
} from './TaskAttachmentsModal-style';
import { ITaskAttachmentsModalProps } from './TaskAttachmentsModal-type';
import Icon from '../../../../../components/Icon';
import { getDomainAndPort } from '../../../../../api/Utils';

const { domainFeatures } = getDomainAndPort();

export const TaskAttachmentsModal = (
  props: ITaskAttachmentsModalProps
): ReactElement => {
  useBaseComponent<ITaskAttachmentsModalProps>({
    props,
  });

  const {
    isActive,
    attachments,
    selectedIndex,
    users,
    onIndexChanged,
    onClose,
    editableToken,
  } = props;
  const { [selectedIndex]: attachment } = attachments;
  const { document, senderId } = attachment;
  const { properties, url, uploadDate, fileSize } = document;
  const { format } = properties;
  // const [formatType] = format.split('/');
  // const isImage: boolean = formatType === 'image';

  const allowDownload = editableToken ? true : !domainFeatures?.preventDownload;

  return (
    <Modal
      isActive={isActive}
      title={messages.title}
      onClose={(): void => {
        onClose();
      }}
      mainStyle={{ overflow: 'hidden' }}
      bodyStyle={{ overflow: 'hidden' }}
    >
      <AttachmentFileHolder>
        {onIndexChanged && (
          <>
            <PrevNextButton
              color="green"
              disabled={selectedIndex === attachments.length - 1}
              side="left"
              onClick={(): void => {
                onIndexChanged(selectedIndex + 1);
              }}
            >
              {messages.next} <Icon type="arrow-left" />
            </PrevNextButton>
            <PrevNextButton
              color="green"
              disabled={selectedIndex === 0}
              side="right"
              onClick={(): void => {
                onIndexChanged(selectedIndex - 1);
              }}
            >
              <Icon type="arrow-right" /> {messages.previous}
            </PrevNextButton>
          </>
        )}
        {allowDownload && (
          <AttachmentModalDownloadLink href={url} target="_blank">
            {properties.displayName} ({messages.downloadText})
          </AttachmentModalDownloadLink>
        )}
        {users && (
          <AttachmentModalInfo>
            آپلود شده در{' '}
            {convertDigitToProperFormat(
              moment(uploadDate).format('jYYYY/jMM/jDD , HH:mm')
            )}{' '}
            توسط <b>{users[senderId]?.name}</b>
          </AttachmentModalInfo>
        )}
        <AttachmentModalImageHolder>
          <FileViewer url={url} fileMimeType={format} size={fileSize} />
        </AttachmentModalImageHolder>
      </AttachmentFileHolder>
    </Modal>
  );
};
